import React, { Component, Fragment } from "react"
import { OnboardingHeader } from "components/OnboardingHeader"
import { toLower } from 'ramda'
import EmailSnippetModal from 'layouts/OnboardingInstallStep/EmailSnippetModal'
import { track } from 'utils/trackingUtils'
import { Card } from '@drifthq/tide-core'

import "./style.css"

import { INSTALL_OPTIONS } from '../constants'

export const InstallLink = ({ text, linkText, onClick }) => (
  <div className="setup-install-link">
    {text}
    <a onClick={onClick}>
      {linkText}
    </a>
  </div>
)

export const trackTeammateInstall = ({ stepName }) => {
  track(`${stepName} - Teammate Request Clicked`, { CTA: 'email snippet to teammate', text: 'Send to a teammate', type: 'link' })
}

class OnboardingInstallStep extends Component {

  constructor(props) {
    super(props)
    this.state = { showInviteModal: false }
  }

  trackInstall = ({ eventType, ctaInfo='' }) => {
    const { name } = this.props
    const stepName = `${name} Install`
    switch (eventType) {
      case 'clicked':
        track(`${stepName} - Option Clicked`, { key: ctaInfo })
        break
      case 'skipped':
        track(`${stepName} - Skipped`, { CTA: 'skip install step', text: 'Skip this step', type: 'link' })
        break
      case 'requested':
        trackTeammateInstall( { stepName })
        break
      default:
    }
  }

  renderInstallCards = (history, path) => {
    return INSTALL_OPTIONS.map(item =>
        <Card
          imgSrc={item.logoSrc}
          header={item.title}
          onClick={() => {
            this.trackInstall({ eventType: 'clicked', ctaInfo: toLower(item.title) })
            history.push(path + item.path)}}
          className="install-option-card"/>
    )
  }

  render() {
    const { onContinue, history, path, name } = this.props
    const { showInviteModal } = this.state

    return (
      <Fragment>
        <div className="setup-install-wrapper">
          <OnboardingHeader
            title="Let’s get Drift installed!"
            description="Don’t worry — installing Drift won’t make any changes to your website now. This step should only take a few minutes, and put you on the fast track to getting value!"
          />
          <div className="install-option-card-row">{this.renderInstallCards(history, path)}</div>
          <InstallLink
            text="Need help from a teammate?"
            linkText="Send to a teammate"
            onClick={() => {
              this.trackInstall({ eventType: 'requested' })
              this.setState({
                showInviteModal: true
              })
            }}
          />
          <InstallLink
            text="Not ready to install just yet? "
            linkText="Skip this step"
            onClick={() => {
              onContinue()
              this.trackInstall({ eventType: 'skipped' })
            }}
          />
        </div>
        { showInviteModal && <EmailSnippetModal onClose={()=> {this.setState({ showInviteModal: false }) }} name={name}/> }
      </Fragment>
    )
  }
}

export default OnboardingInstallStep



// WEBPACK FOOTER //
// ./src/layouts/OnboardingInstallStep/InstallOptions/index.js